import { render, staticRenderFns } from "./EdenCollapseItem.vue?vue&type=template&id=0f837510"
import script from "./EdenCollapseItem.vue?vue&type=script&lang=js"
export * from "./EdenCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./EdenCollapseItem.vue?vue&type=style&index=0&id=0f837510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports